import { useCallback, useState } from "react";

import InputMask from "../InputMask";
import http from "infra/http";
import { Button } from "@chakra-ui/button";
import { Box } from "@chakra-ui/layout";
import colors from "core/resources/theme/colors";

export interface CepResponse {
  rua: string;
  cep: string;
  estadoId: string;
  cidadeId: string;
  estado: string;
  cidade: string;
  bairro: string;
}

interface InputCepProps {
  value: any;
  onChange: (val: any) => any;
  onLoadCep: (data: CepResponse) => any;
}
function InputCep({
  value,
  onChange,
  onLoadCep,
  ...props
}: InputCepProps & Record<string, any>) {
  const [isLoading, setIsLoading] = useState(false);

  const handleCep = useCallback(async () => {
    if (!value) {
      return;
    }

    try {
      setIsLoading(true);

      const { data } = await http.get(
        `/v1/buscar-cep/${value.replace(/[^0-9]/g, "")}`
      );

      onLoadCep(data);
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  }, [onLoadCep, value]);

  return (
    <Box position="relative">
      <InputMask
        placeholder="XXXXX-XXX"
        mask="99999-999"
        value={value}
        onChange={(v: any) => {
          onChange(v);
        }}
        onKeyDown={(ev) => {
          if (ev.keyCode === 13 && typeof onLoadCep === "function") {
            handleCep();
          }
        }}
        {...props}
      />
      <Button
        isLoading={isLoading}
        disabled={isLoading}
        position="absolute"
        right="4px"
        bg={colors.primary}
        color={colors.white}
        _hover={{
          bg: colors.primaryDark,
        }}
        bottom="4px"
        size="sm"
        onClick={() => {
          if (typeof handleCep === "function") {
            handleCep();
          }
        }}
      >
        {isLoading ? null : "Buscar"}
      </Button>
    </Box>
  );
}

export default InputCep;
